export default __webpack_public_path__ + "media/Azure.228efe27.svg";